@if (item(); as e) {
<section class="page">
  <div class="container">
    <nav class="crumbs" aria-label="Breadcrumb">
      <ol>
        <li><a routerLink="/">Home</a></li>
        <li><a routerLink="/equipment">Equipment</a></li>
        <li aria-current="page">{{ e.name }}</li>
      </ol>
    </nav>

    <div class="detail">
      <figure class="detail__media" appReveal>
        <img [src]="e.image" [alt]="e.name + ' supplied by Mechtron Water Services'"
             width="1000" height="667" decoding="async">
      </figure>

      <div class="detail__body" appReveal [revealDelay]="80">
        <p class="eyebrow">{{ e.stage | uppercase }}</p>
        <h1>{{ e.name }}</h1>
        <p class="detail__summary">{{ e.summary }}</p>
        @for (para of e.body; track para) { <p>{{ para }}</p> }

        <h2>Typical specification</h2>
        <dl class="specs">
          @for (s of e.specs; track s.label) {
            <dt>{{ s.label }}</dt>
            <dd>{{ s.value }}</dd>
          }
        </dl>

        <div class="detail__actions">
          <a routerLink="/contact-us" [queryParams]="{ about: e.slug }" class="btn btn--primary">Request a quote</a>
          <a href="https://wa.me/918983643660" target="_blank" rel="noopener noreferrer"
             class="btn btn--ghost btn--dark">WhatsApp</a>
        </div>
      </div>
    </div>
  </div>
</section>
}
